import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Program from './pages/Program';
import InTouch from './pages/InTouch';
import Admin from './pages/Admin';
import '@questlabs/react-sdk/dist/style.css';

// ScrollToTop component to reset scroll on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-background-light text-slate-800 font-body selection:bg-secondary selection:text-white relative overflow-x-hidden">
        {/* Fixed hex-pattern overlay */}
        <div className="fixed inset-0 pointer-events-none z-0 opacity-40 bg-hex-pattern" />

        {/* Top-left corner hexagon decorations */}
        <div className="absolute top-0 left-0 w-64 h-64 pointer-events-none z-0 hidden md:block">
          <svg
            className="w-full h-full fill-none"
            style={{ stroke: 'rgba(14,165,233,0.3)' }}
            strokeWidth="1.5"
            viewBox="0 0 200 200"
          >
            <path d="M50 20 L90 40 L90 80 L50 100 L10 80 L10 40 Z" />
            <path d="M120 10 L160 30 L160 70 L120 90 L80 70 L80 30 Z" />
            <path d="M40 90 L80 110 L80 150 L40 170 L0 150 L0 110 Z" />
          </svg>
        </div>

        {/* Top-right corner hexagon decorations */}
        <div className="absolute top-0 right-0 w-64 h-64 pointer-events-none z-0 hidden md:block">
          <svg
            className="w-full h-full fill-none"
            style={{ stroke: 'rgba(14,165,233,0.3)' }}
            strokeWidth="1.5"
            viewBox="0 0 200 200"
          >
            <path d="M150 20 L190 40 L190 80 L150 100 L110 80 L110 40 Z" />
            <path d="M80 10 L120 30 L120 70 L80 90 L40 70 L40 30 Z" />
            <path d="M160 90 L200 110 L200 150 L160 170 L120 150 L120 110 Z" />
          </svg>
        </div>

        <Navbar />
        <main className="flex-grow relative z-10">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Navigate replace to="/program" />} />
              <Route path="/program" element={<Program />} />
              <Route path="/intouch" element={<InTouch />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer />

        {/* Bottom animated circuit SVGs */}
        <div className="fixed bottom-0 left-0 w-full h-48 md:h-64 pointer-events-none z-0">
          <svg
            className="absolute bottom-0 left-0 w-1/3 h-full opacity-20"
            style={{ color: '#0056b3' }}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 300 200"
          >
            <path className="circuit-line" d="M10 200 V 150 L 30 130 V 100 L 50 80 V 40" />
            <circle cx="50" cy="40" fill="currentColor" r="3" />
            <path className="circuit-line" d="M30 200 V 180 L 60 150 V 120" />
            <circle cx="60" cy="120" fill="currentColor" r="3" />
            <path className="circuit-line" d="M60 200 V 190 L 100 190 L 120 170 H 150" />
            <circle cx="150" cy="170" fill="currentColor" r="3" />
          </svg>
          <svg
            className="absolute bottom-0 right-0 w-1/3 h-full opacity-20"
            style={{ color: '#0056b3', transform: 'scaleX(-1)' }}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 300 200"
          >
            <path className="circuit-line" d="M10 200 V 140 L 40 110 V 50" />
            <circle cx="40" cy="50" fill="currentColor" r="3" />
            <path className="circuit-line" d="M50 200 V 170 H 90 L 110 150 H 160" />
            <circle cx="160" cy="150" fill="currentColor" r="3" />
          </svg>
        </div>
      </div>
    </Router>
  );
}

export default App;
